import ComponentGuard from "./ComponentGuard.vue";
import permissionMixin from "./permissionMixin.js";

export { ComponentGuard, permissionMixin };


// WEBPACK FOOTER //
// ./src/components/Permissions/index.js